import React from 'react';

const ClosedNotice = () => {
  return (
    <div
      style={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'sans-serif',
        textAlign: 'center',
        padding: '24px',
      }}
    >
      <h1 style={{ fontSize: '1.5rem', marginBottom: '12px' }}>
        本サイトは運用を終了しました
      </h1>
      <p style={{ color: '#666', margin: 0 }}>長らくのご利用ありがとうございました。</p>
    </div>
  );
};

export default ClosedNotice;
